import { isEmpty, trim } from 'lodash';
import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { loginPopup as LoginPopup, PrintOptions } from '../../shared/index';
// import { loaderViewNew as LoaderViewNew } from '../../shared/loaderViewNew';

export const testDataManagementView = (props) => {
  const {
    requirementVal,
    onChange,
    // onCancel,
    onDone,
    openModal,
    // openNewModal,
    showDocError,
    openErrorModal,
    closePopup,
    closeErrorPopup,
    // jiraVal,
    openPopup,
    selectedModel,
    selectedProvider,
    llmModels,
    handleChangellm,
    // openNewPopup,
    showRequirement,
    // isSaveCheck,
    regionType,
    regionOption,
    industryOption,
    industryType,
    showBusiness,
    // onSaveData,
    // onAddTable,
    // showDoc,
    // onChangeRadioButton,
    sampleAllData,
    sampleGeneratedData,
    finalGeneratedData,
    dbType,
    errorMessage,
    dbOption,
    onDownloadSave,
    generateAllData,
    countGenerate,
    countSave,
    sampleNoData,
    sampleYesData,
    showFinalData,
    isLoading,
    isLoadingButton,
    businessRules,
    businessRulesCopy,
    redirectToAnotherPage,
    backtostep1,
    backtostep2,
    totalVal,
    dataLength,
    onUpload,
    submitRequirement,
    // requirementRadio
  } = props;
  let view = null;
  // if (isLoading) {
  //   view = <LoaderViewNew />;
  // } else
  if (errorMessage === 'failure' || errorMessage === 'junkerror') {
    view = (
      <div className='superAdmin__container'>
        <Modal
          show={openErrorModal}
          onHide={closeErrorPopup}
          size='sm'
          dialogClassName='modal-10w'
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Body style={{ padding: '15px 30px' }}>
            <div className='mb-2'>
              <LoginPopup />
            </div>
            <div>{errorMessage === 'junkerror' ? 'Please provide valid requirement details and try again!' : 'There seems to be a problem. Please try again later'}</div>
            <button
              className='btn btn-color mt-3'
              onClick={() => closeErrorPopup()}
            >
              Ok
            </button>
          </Modal.Body>
        </Modal>
      </div>
    );
  } else {
    const disableButton = isEmpty(trim(requirementVal));
    const disableImportButton = isEmpty(trim(dbType));
    const disableImportOption = isEmpty(trim(regionType)) && isEmpty(trim(industryType));

    view = (
      <div className='superAdmin__container'>
        {/* <Modal
          show={openNewModal}
          onHide={closePopup}
          size='sm'
          dialogClassName='modal-10w'
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Body style={{ padding: '15px 30px' }}>
            <div className='mb-2'>
              <LoginPopup />
            </div>
            <div>Do you want to stay on this page</div>
            <button
              className='btn btn--viewai mt-3'
              onClick={() => closePopup()}
            >
              Yes
            </button>
            <button
              className='btn btn--viewai mt-3 mx-3'
              onClick={() => redirectToAnotherPage()}
            >
              No
            </button>
          </Modal.Body>
        </Modal> */}
        <Modal
          show={openModal}
          onHide={closePopup}
          size='m'
          dialogClassName='modal-30w'
          aria-labelledby='contained-modal-title-vcenter'
          centered
        >
          <Modal.Header closeButton>
            <h5 className='user__heading'>
              Import Schema Definition
            </h5>
          </Modal.Header>
          <Modal.Body>
            <div className='card login-form'>
              <div className='card-body'>
                <div className='card-text'>
                    <div>
                      {showDocError ? (
                        <div style={{ color: 'red' }}>
                          *Please upload word(.docx) file
                        </div>
                      ) : (
                        ''
                      )}
                      <div className='form-group mt-2'>
                        <input
                          type='file'
                          name='documentVal'
                          id='documentVal'
                          accept='application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel'
                          // value={documentVal}
                          className='form-control upload--document'
                          onChange={(eve) => onUpload(eve)}
                        />
                      </div>
                    </div>
                  <button
                    type='submit'
                    onClick={() => submitRequirement()}
                    className='btn btn-primary mt-3 user__submit_btn'
                  >
                    Submit
                  </button>
                  {isLoadingButton ? (
                    <div
                      className='spinner-border spinner-color'
                      id='loaderTestCase'
                    ></div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        <h3 className='center-align-div mb-4'>Review and Generate Data</h3>
        <ul className='list-unstyled multi-steps'>
          <li id='firstli' className='is-active' onClick={() => backtostep1()}>
            Import Data/Schema Details
          </li>
          <li id='secondli' className='' onClick={() => backtostep2()}>
            Review Sample Data
          </li>
          <li id='thirdli' className=''>
            Generate Data
          </li>
        </ul>
        {showRequirement ? (
          <div className='row'>
            <div className='mt-3 center-align-div'>
              <div className='mb-3'>
                <div key={'app_neww'} className='row mb-3'>
                  <label className='col-sm-2 col-form-label'>
                    {'Industry:'}
                  </label>
                  <div className='col-sm-4'>
                    <select
                      onChange={(eve) =>
                        onChange({
                          id: 'industryType',
                          value: eve.currentTarget.value
                        })
                      }
                      className='form-select'
                    >
                      <PrintOptions value={industryType} options={industryOption} />
                    </select>
                  </div>
                  <label className='col-sm-2 col-form-label'>
                    {'Region:'}
                  </label>
                  <div className='col-sm-4'>
                    <select
                      onChange={(eve) =>
                        onChange({
                          id: 'regionType',
                          value: eve.currentTarget.value
                        })
                      }
                      className='form-select'
                    >
                      <PrintOptions value={regionType} options={regionOption} />
                    </select>
                  </div>
                </div>
                <div key={'app_new'} className='row mb-3'>
                  <label className='col-sm-2 col-form-label'>
                    {'Input Source:'}
                  </label>
                  <div className='col-sm-4'>
                    <select
                      onChange={(eve) =>
                        onChange({
                          id: 'dbType',
                          value: eve.currentTarget.value
                        })
                      }
                      className='form-select'
                      disabled={disableImportOption}
                    >
                      <PrintOptions value={dbType} options={dbOption} />
                    </select>
                  </div>
                  <div className='col-sm-4'>
                  <button
                className={`btn btn--viewai ${
                  disableImportButton ? 'btn--disabled' : ''
                }`}
                disabled={disableImportButton}
                onClick={() => openPopup()}
              >
                Import Schema Definition
              </button>
                    </div>
                </div>
                <h6 className='mb-2'>Schema details</h6>
                <textarea
                  className='form-control textarea-height scrollbar-deep bordered-deep thin'
                  id='requirementVal'
                  rows='8'
                  disabled={disableImportButton}
                  value={requirementVal}
                  onChange={(eve) =>
                    onChange({ id: eve.target.id, value: eve.target.value })
                  }
                  placeholder='Please provide schema details here..'
                  required
                ></textarea>
              </div>
              <div className='mt-3 mb-3'>
                <label htmlFor='dataValidation' className='form-label'>
                 <h6> Please provide your data rules/validations, if any</h6>
                </label>
                <textarea
                  className='form-control textarea-height scrollbar-deep bordered-deep thin'
                  id='businessRules'
                  value={businessRules}
                  rows='4'
                  onChange={(eve) =>
                    onChange({ id: eve.target.id, value: eve.target.value })
                  }
                  placeholder='Please provide your data rules/validations here..'
                  disabled={disableImportButton}
                ></textarea>
              </div>
              <div className='row'>
                <div className='col-sm-3'>
                  <select
                  value={`${selectedProvider}|${selectedModel}`}
                  onChange={(eve) => handleChangellm(eve)}
                  className='form-select'
                >
                  {Object.entries(llmModels).map(([provider, models]) => (
                    <optgroup key={provider} label={provider.toUpperCase()}>
                      {Object.entries(models).map(([key, label]) => (
                        <option key={key} value={`${provider}|${key}`}>
                          {label}
                        </option>
                      ))}
                    </optgroup>
                  ))}
                </select>
                </div>
                <div className='col-sm-3'>

                </div>
                <div className='col-sm-6'>
                <button
                  className={`btn btn--viewai float-end ${disableButton ? 'btn--disabled' : ''
                    }`}
                  onClick={() => onDone('generate')}
                  disabled={disableButton || isLoading}
                >
                  Generate Sample Data
                </button>
                {isLoading ? (
                  <div
                    className='spinner-border spinner-color'
                    id='loaderTestCase'
                  ></div>
                ) : (
                  ''
                )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          ''
        )}
        {showBusiness ? (
          <div className='row mt-3'>
            <div className='mt-3 center-align-div'>
              <div className='mt-2 mb-3'>
                <h6 className='heading heading__level2 mb-4'>
                  Generated Sample Data
                </h6>
                {/* <textarea
                  className='form-control validation-height scrollbar-deep bordered-deep thin'
                  id='sampleGeneratedData'
                  value={sampleGeneratedData}
                  rows='4'
                  onChange={(eve) =>
                    onChange({ id: eve.target.id, value: eve.target.value })
                  }
                  placeholder='Sample generated data here..'
                ></textarea> */}
                <pre id='generatedSampleVal'
                  className='border scrollbar-deep genrated-sample-data thin p-2'
                  >{sampleGeneratedData}</pre>
              </div>
              <div className='col-sm-12 mb-2'>
                Please confirm if you are fine with the sample data generated
              </div>
              <button
                id='sampleYes'
                className='btn btn-color mb-2'
                onClick={() => sampleAllData('yes')}
                disabled={sampleNoData}
              >
                Yes
              </button>
              <button
                id='sampleNo'
                className='btn btn-color mb-2 mx-4'
                onClick={() => sampleAllData('no')}
                disabled={sampleYesData}
              >
                No
              </button>
              {sampleNoData && (
                <>
                  <div className='mt-3 mb-3'>
                    <label htmlFor='dataValidation' className='form-label'>
                      Please provide your data rules/validations, if any
                    </label>
                    <textarea
                      className='form-control textarea-height scrollbar-deep bordered-deep thin'
                      id='businessRulesCopy'
                      value={businessRulesCopy}
                      rows='4'
                      onChange={(eve) =>
                        onChange({ id: eve.target.id, value: eve.target.value })
                      }
                      placeholder='Please provide your data rules/validations here..'
                    ></textarea>
                  </div>
                  <button
                    onClick={() => onDone('regenerate')}
                    id='generateSampleData'
                    className='btn btn-color float-end mb-2'
                    disabled={isLoading}
                  >
                    Re-Generate Sample Data
                  </button>{' '}
                  {isLoading ? (
                    <div
                      className='spinner-border spinner-color'
                      id='loaderTestCase'
                    ></div>
                  ) : (
                    ''
                  )}
                </>
              )}
              {sampleYesData && (
                <>
                  <div className='form-group row'>
                    <label
                      htmlFor='numValidation'
                      className='col-sm-4 col-form-label'
                    >
                      No. of records to be generated:
                    </label>
                    <div className='col-sm-3 mb-3'>
                      <input
                        type='number'
                        className='form-control'
                        id='totalVal'
                        max='5000'
                        min='0'
                        onChange={(eve) =>
                          onChange({
                            id: eve.target.id,
                            value: eve.target.value
                          })
                        }
                        value={totalVal}
                        placeholder='Records...'
                        required
                      />
                    </div>
                    <div className='col-sm-3'></div>
                  </div>
                  <button
                    onClick={() => generateAllData()}
                    id='generateSampleData'
                    className='btn btn-color float-end mb-2'
                    disabled={totalVal === 0 || isLoading}
                  >
                    Generate Data
                  </button>
                  {isLoading ? (
                    <div
                      className='spinner-border spinner-color'
                      id='loaderTestCase'
                    ></div>
                  ) : (
                    ''
                  )}
                </>
              )}
            </div>
          </div>
        ) : (
          ''
        )}
        {showFinalData ? (
          <div className='row mt-2'>
            <div className='col-lg-6'>
              <div className='mt-2 mb-3'>
                <h6>Schema details</h6>
                <textarea
                  className='form-control textarea-height scrollbar-deep bordered-deep thin'
                  id='requirementCheck'
                  rows={
                    businessRules !== '' || businessRulesCopy !== '' ? 8 : 15
                  }
                  value={requirementVal}
                  placeholder='Please provide schema details here..'
                  disabled='true'
                ></textarea>
              </div>
              {businessRules !== '' || businessRulesCopy !== '' ? (
                <div className='mt-3 mb-3'>
                  <h6>Please provide your data rules/validations, if any</h6>
                  <textarea
                    className='form-control textarea-height scrollbar-deep bordered-deep thin'
                    id='dataValidationCheck'
                    rows='5'
                    value={
                      businessRulesCopy === ''
                        ? businessRules
                        : businessRulesCopy
                    }
                    placeholder='Please provide your data rules/validations here..'
                    disabled='true'
                  ></textarea>
                </div>
              ) : (
                ''
              )}
            </div>
            <div className='col-lg-1'></div>
            <div className='col-lg-5'>
              <div className='mt-2 mb-3'>
                <h6 className='heading heading__level2'>Generated Data</h6>
                <pre
                  id='businessAllVal'
                  className='border scrollbar-deep genrated-pre-data thin p-2'
                >
                  {finalGeneratedData}
                </pre>
              </div>
              <button
                className='btn btn--viewai px-3'
                onClick={(eve) => onDownloadSave(eve, 'download')}
                disabled={isLoadingButton || countSave}
              >
                Save Data Snapshot
              </button>
              <button
                className='btn btn--viewai mx-3 px-3'
                onClick={(eve) => onDownloadSave(eve, 'save')}
                disabled={isLoadingButton || countGenerate}
              >
                Generate Data Query
              </button>
              {/* <button
                className='btn btn--viewai mx-3 px-3'
                onClick={() => redirectToAnotherPage()}
                disabled={isLoadingButton}
              >
                Exit
              </button> */}
              {isLoadingButton ? (
                <div
                  className='spinner-border spinner-color'
                  id='loaderTestCase'
                ></div>
              ) : (
                ''
              )}
             { dataLength >= totalVal ? "" : <div className='limit_text'><b>Note:</b> The number of records generated are less due to model / token limit exhaustion.</div>}
            </div>
          </div>
        ) : (
          ''
        )}
      </div>
    );
  }
  return <div className='page--superAdmin'>{view}</div>;
};
